<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.0002 7V12.5C18.0002 14.1569 16.657 15.5 15.0002 15.5H10.4144L12.7073 17.7929L11.293 19.2071L6.58594 14.5L10.793 10.2929L12.2073 11.7071L10.4144 13.5H15.0002C15.5524 13.5 16.0002 13.0523 16.0002 12.5V7H18.0002Z" fill="#B8B8B8"/>
</svg>
